module.exports = __webpack_public_path__ + "static/media/background.fc8537d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.svg
// module id = 47
// module chunks = 0